import SubscriptionPlansApi from '@/api/subscription-plans';

const defaultState = () => ({
  plans: null,
});

export default {
  namespaced: true,
  state: defaultState(),
  mutations: {
    setSubscriptionPlans(state, payload) {
      state.plans = payload;
    },
  },
  actions: {
    async get({ commit }) {
      const { data } = await SubscriptionPlansApi.get();
      commit('setSubscriptionPlans', data);
    },
  },
  getters: {
    plans: state => state.plans,
    isSetup: (state, getters) => Boolean(getters.plans),
  },
};
